<template>
  <div>
    <!-- header -->
    <head-menu></head-menu>

    <!-- banner -->
    <div class="page-head">
      <img src="~@/common/imgs/honor.jpg" alt="">
    </div>

    <!-- content -->
    <div class="news-content">
      <div class="news-left">
        <dl>
          <dt>
            <h3>集团介绍</h3>
            <p>Group Introduction</p>
          </dt>
          <dd class="w25">
            <router-link to="Intro"><span>企业简介</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link to="Architecture"><span>企业架构</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link to="Culture"><span>企业文化</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link to="DevelopmentCourse"><span>发展历程</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link to="Responsibility" class="active"><span>社会责任</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
        </dl>
      </div>

      <div class="news-right">
        <div class="news-bread">
          <h2>集团介绍</h2>/<i>社会责任</i>
        </div>
        <div class="imgs-list">
          <div class="list-title"><h3>社会责任与荣誉</h3></div>
          <ul>
            <li v-for="item in zeren" :key="item.id"><img :src="item.attachmentVos[0].fileVo.url"><p class="imgText">{{item.title}}</p></li>
          </ul>
        </div>
      </div>
    </div>

    <!-- footer -->
    <foot-link></foot-link>
     <!-- 回到顶部 -->
    <el-backtop></el-backtop>
    <router-view></router-view>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import axios from 'axios'
  import global_msg from '@/common/js/global.js'

  export default {
    name: 'PjHonor',
    data() {
      return {
        url: global_msg.baseUrl,
        zeren: [],//社会责任,
      }
    },
    components: {
      'head-menu': Header,
      'foot-link': Footer
    },
    created() {
      // axios.get(global_msg.baseUrl + 'ntWebsiteinfo/findHonor?page=1&rows=10000&nwcId=31').then((response) => {
      //   this.zeren = response.data.rows;
      // });
      axios.get(global_msg.baseUrl + 'companyOfficialWebsite/findByAll?sendType=社会责任').then((response) => {
        this.zeren = response.data.subject.result;
      });
    }
  }
</script>

<style scoped>
  .imgs-list li{
    margin-bottom: 0.66rem;
  }
  .imgs-list li:nth-child(3n){
    margin-right: .16rem;
  }
  .imgText{
    text-align: center;
    font-size: 20px;
    padding-top:10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Responsibility.vue